module.exports = __webpack_public_path__ + "img/avatar-s-5.50ed9b46.jpg";